import React from 'react'
import {
    Card, CardHeader, CardTitle, CardBody,
    Row, Col
} from "reactstrap";
import { FileEarmarkArrowUp, Display, Telephone, HddNetwork, Speedometer2, PiggyBank } from 'react-bootstrap-icons';

const Advantages = (props) => {
    const {getBackBtn, noCard} = props
    return (<>
        <CardTitle className={'mt-5 h3'} tag="h2">
            Korzyści z użytkowania aplikacji
        </CardTitle>
        <Card style={noCard?{boxShadow:'none'}:{}}>
            <CardBody className='p-4'>
                <Row>
                    <Col md='4' style={{alignSelf: 'center'}}>
                        <Row className='mainAdvRow'>
                            <Col md='4' className='text-center'>
                                <FileEarmarkArrowUp alt={'FileEarmarkArrowUp'} title={'FileEarmarkArrowUp'} className='fa-3x iconColor' />
                                {/* <i class="fas fa-upload fa-4x"></i> */}
                            </Col>
                            <Col md='8'>
                                <div className='rowTile'>
                                    wprowadzenie danych poprzez import z&nbsp;plików bądź bezpośrednio w&nbsp;aplikacji
                                </div>
                            </Col>
                        </Row>
                        <Row className='mainAdvRow'>
                            <Col md='8'>
                                <div className='rowTile'>
                                    wdrożenie niezależnie od&nbsp;posiadanych systemów informatycznych świadczeniodawcy
                                </div>
                            </Col>
                            <Col md='4' className='text-center'>
                                <Display alt={'Display'} title={'Display'} className='fa-3x iconColor' />
                                {/* <i class="fas fa-desktop fa-4x"></i> */}
                            </Col>
                        </Row>
                        <Row className='mainAdvRow'>
                            <Col md='4' className='text-center'>
                                <Telephone alt={'Telephone'} title={'Telephone'} className='fa-3x iconColor' />
                                {/* <i class="fas fa-phone fa-4x flipHorizontally"></i> */}
                            </Col>
                            <Col md='8'>
                                <div className='rowTile'>
                                    wsparcie AOTMiT dla&nbsp;podmiotów na&nbsp;każdym etapie wdrożenia
                                </div>
                            </Col>
                        </Row>
                        <Row className='mainAdvRow'>
                            <Col md='8'>
                                <div className='rowTile'>
                                    dostęp do danych w&nbsp;jednym miejscu
                                </div>
                            </Col>
                            <Col md='4' className='text-center'>
                                <HddNetwork alt={'HddNetwork'} title={'HddNetwork'} className='fa-3x iconColor' />
                                {/* <i class="fas fa-link fa-4x"></i> */}
                            </Col>
                        </Row>
                        <Row className='mainAdvRow'>
                            <Col md='4' className='text-center'>
                                <Speedometer2 alt={'Speedometer2'} title={'Speedometer2'} className='fa-3x iconColor' />
                                {/* <i class="fas fa-tachometer-alt fa-4x"></i> */}
                            </Col>
                            <Col md='8'>
                                <div className='rowTile'>
                                    porównanie swoich wskaźników ekonomiczno-&#8203;finansowych z&nbsp;innymi podmiotami w&nbsp;Polsce
                                </div>
                            </Col>
                        </Row>
                        <Row className='mainAdvRow'>
                            <Col md='8'>
                                <div className='rowTile'>
                                    bezpłatny dostęp do&nbsp;aplikacji
                                </div>
                            </Col>
                            <Col md='4' className='text-center'>
                                <PiggyBank alt={'PiggyBank'} title={'PiggyBank'} className='fa-3x iconColor' />
                                {/* <i class="fas fa-piggy-bank fa-4x flipHorizontally"></i> */}
                            </Col>
                        </Row>
                    </Col>

                    <Col>
                        <div className='mainAdvTile tile-light'>
                            <CardTitle tag='h3'>
                                <i class="fas fa-hospital-alt fa-2x"></i>
                                <span>Małe podmioty<br/>lecznicze</span>
                            </CardTitle>
                            {/* <hr /> */}
                            <div className='tileBody'>
                                <div> usprawnienie procesu rozliczania kosztów (automatyzacja procesu w&nbsp;aplikacji) </div>
                                <div> skrócenie pracochłonności związanej z&nbsp;rozliczaniem kosztów </div>
                                <div> uzyskanie informacji zarządczej, wspierającej Dyrekcję/Kierownictwo w&nbsp;podejmowaniu
                                    bieżących decyzji związanych z&nbsp;alokacją środków finansowych
                                    wewnątrz jednostek oraz&nbsp;sporządzaniem planów finansowych i&nbsp;inwestycyjnych
                                </div>
                                <div>zwiększenie efektywności zarządzania zasobami i&nbsp;ich&nbsp;kosztami</div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className='mainAdvTile tile-medium'>
                            <CardTitle tag='h3'>
                                <i class="fas fa-hospital-alt fa-3x"></i>
                                <span>Średnie podmioty<br/>lecznicze</span>
                            </CardTitle>
                            {/* <hr /> */}
                            <div className='tileBody'>
                                <div> poprawa wykorzystania zasobów </div>
                                <div> zwiększenie efektywności procesów operacyjnych (automatyzacja procesów) </div>
                                <div> przystępnie przedstawiona informacja o&nbsp;kosztach prowadzenia działalności, możliwość zapewnienia ww.&nbsp;informacji szerokiemu gronu pracowników </div>
                                <div> wsparcie w&nbsp;procesie delegowania </div>
                                <div> wsparcie analityczne w&nbsp;procesie podejmowania decyzji </div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className='mainAdvTile tile-dark'>
                            <CardTitle tag='h3'>
                                <i class="fas fa-hospital-alt fa-4x"></i>
                                <span>Duże podmioty<br/>lecznicze</span>
                            </CardTitle>
                            {/* <hr /> */}
                            <div className='tileBody'>
                                <div>rozpoznanie obszarów o&nbsp;dużym potencjale rozwoju</div>
                                <div>łatwa prezentacja wyników dot.&nbsp;procesów kosztowych wewnątrz organizacji</div>
                                <div>wsparcie w&nbsp;długoterminowym planowaniu działalności</div>
                                <div>zwiększenie konkurencyjności</div>
                                <div>analizy zmieniających&nbsp;się trendów</div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
        {getBackBtn()}
    </>)
}
export default Advantages
